const registerServiceWorker = () => {
    if ("serviceWorker" in navigator) {
        window.addEventListener('load', function() {

            navigator.serviceWorker
                .register("/firebase-messaging-sw.js", { scope: "messaging-sw" })
                .then(function(registration) {
                    console.log("Registration successful, scope is:", registration.scope);
                    if (registration.installing) {
                        console.log('Service worker installing');
                    } else if (registration.waiting) {
                        console.log('Service worker installed');
                    } else if (registration.active) {
                        console.log('Service worker active');
                    }
                })
                .catch(function(err) {
                    console.log("Service worker registration failed, error:", err);
                });
        });
    }

};

export { registerServiceWorker };


// WEBPACK FOOTER //
// ./src/register-sw.js